<template>
    <div class="StepHead">
        <div class="Steps">
            <div class="StepsItem">1. 基本信息</div>
        </div>
        <p>注册前请您详细阅读<a @click="GoToAbout">《中国心理卫生协会心理服务专业机构和专业人员注册系统管理办法》</a>(修订)</p>
        <!-- <a href=""></a> -->
        <table width="100%" class="Table">  
            <tbody>
                <tr v-if="TypeId==1">
                    <td width="10%"><span class="Red">*</span>姓名</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetData.name" ></el-input></td>
                    <td width="10%"><span class="Red">*</span>手机号</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetGeRenData.mobile" disabled></el-input></td>
                    <td colspan="2">
                        <label style="margin-right: 10px;"><span class="Red">*</span>是否向公众公布您的工作电话</label>
                        <el-radio-group v-model="SetGeRenData.is_public" size="small">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr v-if="TypeId==1">
                    <td width="10%"><span class="Red">*</span>性别</td>
                    <td width="23%">
                        <el-radio-group v-model="SetGeRenData.gender" >
                            <el-radio label="1">男</el-radio>
                            <el-radio label="2">女</el-radio>
                        </el-radio-group>
                    </td>
                    <td><span class="Red">*</span>出生年月</td>
                    <td><el-date-picker size="small" class="WidMax" value-format="yyyy-MM-dd" type="date" placeholder="请选择" v-model="SetGeRenData.birthday"></el-date-picker></td>
                    <td width="10%">工作电话</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetGeRenData.work_mobile"></el-input></td>
                </tr>
                <tr v-if="TypeId==1">
                    <td><span class="Red">*</span>民族</td>
                    <td>
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.nation">
                            <el-option :label="item.nation" :value="item.nation" v-for="item in MingZuData" :key="item.id"></el-option>
                        </el-select>
                    </td>
                    <td><span class="Red">*</span>籍贯</td>
                    <td><el-cascader size="small" filterable class="WidMax" :props="{value:'name',label:'name',expandTrigger: 'hover' }" v-model="SetGeRenData.native_place" :options="CityData"></el-cascader></td>
                    <td><span class="Red">*</span>婚姻状况</td>
                    <td>
                        <el-select class="WidMax" size="small" placeholder="请选择" v-model="SetGeRenData.marriage">
                            <el-option label="未婚" value="未婚"></el-option>
                            <el-option label="已婚" value="已婚"></el-option>
                        </el-select>
                    </td>
                </tr>
                <tr v-if="TypeId==1">
                    <td width="10%"><span class="Red">*</span>宗教信仰</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetGeRenData.religion" ></el-input></td>
                    <td><span class="Red">*</span>政治面貌</td> 
                    <!-- <td><el-input size="small" placeholder="请输入" v-model="SetGeRenData.political_party"></el-input></td> -->
                    <td>
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.political_party">
                            <el-option :label="item.name" :value="item.name" v-for="item in PoliticalPartyData" :key="item.id"></el-option>
                        </el-select>
                    </td>
                    <td><span class="Red">*</span>学历</td>
                    <td>
                        <el-select class="WidMax" size="small" placeholder="请选择" v-model="SetGeRenData.qualification">
                            <el-option label="无" value="无"></el-option>
                            <el-option label="专科" value="专科"></el-option>
                            <el-option label="本科" value="本科"></el-option>
                            <el-option label="研究生" value="研究生"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </td>
                    
                    
                </tr>
                <tr v-if="TypeId==1">
                    <td><span class="Red">*</span>学位</td>
                    <!-- <td><el-input size="small" placeholder="请输入" v-model="SetGeRenData.degree"></el-input></td> -->
                    <td>
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.degree">
                            <el-option label="学士" value="学士"></el-option>
                            <el-option label="硕士" value="硕士"></el-option>
                            <el-option label="博士" value="博士"></el-option>
                        </el-select>
                    </td>
                    <td><span class="Red">*</span>专业</td>
                    <td>
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.major">
                            <el-option label="精神医学" value="精神医学"></el-option>
                            <el-option label="非精神医学" value="非精神医学"></el-option>
                            <el-option label="心理学" value="心理学"></el-option>
                            <el-option label="护理学" value="护理学"></el-option>
                            <el-option label="教育学" value="教育学"></el-option>
                            <el-option label="社会学" value="社会学"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </td>
                    <td><span class="Red">*</span>技术职称</td>
                    <td>
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.work_title" @change="work_title" >
                            <el-option label="医师" value="医师"></el-option>
                            <el-option label="护士" value="护士"></el-option>
                            <el-option label="心理治疗师" value="心理治疗师"></el-option>
                            <el-option label="大学教师" value="大学教师"></el-option>
                            <el-option label="非大学教师" value="非大学教师"></el-option>
                            <el-option label="研究员" value="研究员"></el-option>
                            <el-option label="无" value="无"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </td>
                    
                    
                </tr>
                <tr v-if="TypeId==1">
                    <td width="10%"><span class="Red">*</span>擅长技术与方法</td>
                    <td width="23%">
                        <el-select v-if="isSkillMethodPreset(SetGeRenData.skill_method)" size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.skill_method" @change="handleSkillMethodChange">
                            <el-option label="精神分析/心理动力" value="精神分析/心理动力"></el-option>
                            <el-option label="认知行为" value="认知行为"></el-option>
                            <el-option label="人本主义" value="人本主义"></el-option>
                            <el-option label="家庭" value="家庭"></el-option>
                            <el-option label="后现代" value="后现代"></el-option>
                            <el-option label="其他（请注明）" value="其他"></el-option>
                        </el-select>
                        <el-input 
                            v-else
                            size="small" 
                            class="WidMax"
                            placeholder="请输入" 
                            v-model="SetGeRenData.skill_method" 
                            @blur="handleOtherInputBlur">
                        </el-input>
                    </td>
                    <td width="10%"><span class="Red">*</span>咨询方向</td>
                    <td width="23%">
                        <el-select v-if="isConsultationDirectionPreset(SetGeRenData.consultation_direction)" size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.consultation_direction" @change="handleConsultationDirectionChange">
                            <el-option label="情绪调节" value="情绪调节"></el-option>
                            <el-option label="恋爱、婚姻与家庭" value="恋爱、婚姻与家庭"></el-option>
                            <el-option label="儿童青少年" value="儿童青少年"></el-option>
                            <el-option label="老年心理" value="老年心理"></el-option>
                            <el-option label="职场心理" value="职场心理"></el-option>
                            <el-option label="人际关系" value="人际关系"></el-option>
                            <el-option label="性心理" value="性心理"></el-option>
                            <el-option label="个人发展与成长" value="个人发展与成长"></el-option>
                            <el-option label="成瘾与行为控制" value="成瘾与行为控制"></el-option>
                            <el-option label="其他（请注明）" value="其他"></el-option>
                        </el-select>
                        <el-input 
                            v-else
                            size="small" 
                            class="WidMax"
                            placeholder="请输入" 
                            v-model="SetGeRenData.consultation_direction" 
                            @blur="handleConsultationDirectionInputBlur">
                        </el-input>
                    </td>
                    <td width="10%"><span class="Red">*</span>社会组织任职</td>
                    <td width="23%" colspan="2">
                        <el-input size="small" class="WidMax" placeholder="请输入" v-model="SetGeRenData.social_organization"></el-input>
                    </td>
                </tr>
                <tr v-if="TypeId==1">
                    <td><span class="Red">*</span>职称等级</td>
                    <td >
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.title_level" @change="$forceUpdate()">
                            <el-option :label="item" :value="item" v-for="item in GradeOptions[SetGeRenData.work_title]" :key="item"></el-option>
                        </el-select>
                    </td>
                    <td><span class="Red">*</span>身份证号码</td>
                    <td><el-input size="small" placeholder="请输入" v-model="SetGeRenData.id_card"></el-input></td>
                    <td><span class="Red">*</span>单位性质</td>
                    <td>
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.nature">
                            <el-option label="医院" value="医院"></el-option>
                            <el-option label="科研机构" value="科研机构"></el-option>
                            <el-option label="高等院校" value="高等院校"></el-option>
                            <el-option label="学校" value="学校"></el-option>
                            <el-option label="地方协会" value="地方协会"></el-option>
                            <el-option label="社会机构" value="社会机构"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </td>
                    <!-- <td><span class="Red">*</span>岗位</td>
                    <td>
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.post">
                            <el-option label="精神科医生" value="精神科医生"></el-option>
                            <el-option label="精神科护士" value="精神科护士"></el-option>
                            <el-option label="心理测查岗" value="心理测查岗"></el-option>
                            <el-option label="心理治疗师" value="心理治疗师"></el-option>
                            <el-option label="心理咨询师" value="心理咨询师"></el-option>
                            <el-option label="心理教师" value="心理教师"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </td> -->
                    <!-- <td><span class="Red">*</span>工作单位</td>
                    <td ><el-input size="small" placeholder="请输入" v-model="SetGeRenData.pf_work"></el-input></td> -->
                </tr>
                <tr v-if="TypeId==1">

                    <td><span class="Red">*</span>工作单位</td>
                    <td colspan="3">
                        <div class="TableDis">
                            <el-input size="small" placeholder="请输入" v-model="SetGeRenData.pf_work"></el-input>
                        </div>
                    </td>
                    <td><span class="Red">*</span>岗位</td>
                    <td>
                        <el-select size="small" class="WidMax" placeholder="请选择" v-model="SetGeRenData.job_content">
                            <el-option label="精神科医生" value="精神科医生"></el-option>
                            <el-option label="精神科护士" value="精神科护士"></el-option>
                            <el-option label="心理测查岗" value="心理测查岗"></el-option>
                            <el-option label="心理治疗师" value="心理治疗师"></el-option>
                            <el-option label="心理咨询师" value="心理咨询师"></el-option>
                            <el-option label="心理教师" value="心理教师"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </td>
                </tr>
                <tr v-if="TypeId==2">
                    <td width="10%"><span class="Red">*</span>机构名称</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetData.name" :disabled="TypeId==1"></el-input></td>
                    <td width="10%"><span class="Red">*</span>机构法人</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetGongSiData.legal_person"></el-input></td>
                    <td width="10%">机构网址</td>
                    <td width="23%"><el-input size="small" placeholder="请输入" v-model="SetGongSiData.mechanism_website"></el-input></td>
                </tr>
                <tr v-if="TypeId==2">
                    <td>机构公众号</td>
                    <td><el-input size="small" placeholder="请输入" v-model="SetGongSiData.mechanism_wnumber"></el-input></td>
                    <td><span class="Red">*</span>营业执照</td>
                    <td>
                        <div class="TableDis">
                            <el-upload action="none" size="small" :show-file-list="false" :http-request="UpFile">
                              <div class="StepCommFileBtn">上传</div>
                            </el-upload>
                            <div class="StepCommFileImg" v-if="SetGongSiData.legal_license">
                                <img :src="$Global.CommImgHttp+SetGongSiData.legal_license" alt="" @click="OpenLock(SetGongSiData.legal_license)">
                            </div>
                        </div>
                    </td>
                    <td><span class="Red">*</span>联系人</td>
                    <td><el-input size="small" placeholder="请输入" v-model="SetGongSiData.link_name"></el-input></td>
                </tr>
                <tr v-if="TypeId==2">
                    <td><span class="Red">*</span>联系电话</td>
                    <td><el-input size="small" placeholder="请输入" v-model="SetGongSiData.link_mobile"></el-input></td>
                    <td><span class="Red">*</span>联系邮箱</td>
                    <td><el-input size="small" placeholder="请输入" v-model="SetGongSiData.link_email"></el-input></td>
                    <td><span class="Red">*</span>单位性质</td>
                    <td>
                        <el-select size="small" class="WidMax" v-model="SetGongSiData.institutions" placeholder="请选择单位性质">
                            <el-option label="科研机构" value="1"></el-option>
                            <el-option label="医疗机构" value="2"></el-option>
                            <el-option label="高等院校" value="3"></el-option>
                            <el-option label="地方协会" value="4"></el-option>
                            <el-option label="社会机构" value="5"></el-option>
                            <el-option label="其他" value="6"></el-option>
                        </el-select>
                    </td>
                </tr>
                <tr v-if="TypeId==2">
                    <td><span class="Red">*</span>业务领域</td>
                    <td>
                        <el-select size="small" class="WidMax" v-model="SetGongSiData.business_field" placeholder="请选择开展业务领域">
                            <el-option label="心理咨询" value="1"></el-option>
                            <el-option label="心理治疗" value="2"></el-option>
                            <el-option label="心理评估" value="3"></el-option>
                            <el-option label="心理健康教育" value="4"></el-option>
                        </el-select>
                    </td>
                    <td colspan="4"></td>
                    <!-- <td><span class="Red">*</span>社会机构</td>
                    <td colspan="3"><el-input size="small" placeholder="请输入" v-model="SetGongSiData.social_institution"></el-input></td> -->
                </tr>
                <tr>
                    <td><span class="Red">*</span>通信地址</td>
                    <td colspan="3">
                        <div class="TableDis">
                            <el-cascader size="small" filterable :props="{value:'id',label:'name',expandTrigger: 'hover' }" v-model="SetData.City" :options="CityData"></el-cascader>
                            <el-input size="small" placeholder="请输入详细地址" v-model="SetData.address"></el-input>
                        </div>
                    </td>
                    <td><span class="Red">*</span>邮箱</td>
                    <td><el-input size="small" placeholder="请输入邮箱" v-model="SetData.email"></el-input></td>
                </tr>
                <tr>
                    <td><span class="Red">*</span>简介</td>
                    <td colspan="3"><el-input size="small" type="textarea" :rows="2" placeholder="请输入" v-model="SetData.synopsis"></el-input></td>
                    <td width="10%">是否对外公布简介</td>
                    <td width="23%">
                        <el-radio-group v-model="SetData.is_public_synopsis" size="small">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                    </td>
                </tr>
                <tr>
                    <td><span class="Red">*</span>收件人</td>
                    <td><el-input size="small" placeholder="请输入收件人姓名" v-model="SetData.receiver_name"></el-input></td>
                    <td><span class="Red">*</span>联系方式</td>
                    <td><el-input size="small" placeholder="请输入收件人手机号" v-model="SetData.receiver_mobile"></el-input></td>
                    <td><span class="Red">*</span>收件人地址</td>
                    <td><el-input size="small" placeholder="请输入收件人详细地址" v-model="SetData.receiver_address"></el-input></td>
                </tr>
            </tbody>
        </table>
        <div class="info-save">注：您所填信息系统会实时保存，请您填写您的最新信息。另，证书邮寄快递为到付</div>
        <div class="StepBtns">
            <div class="StepBtn" @click="ToggleStep" :class="{StpepDisabled:ConfigDisabled}">保存本页并下一步</div>
        </div>
        <!-- <el-dialog title="提示" :visible.sync="TiShiBlon" width="30%" height="150px" center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <span style="display: block; text-align: center;">是否同步您中国心理卫生协会会员注册信息</span>
            <span slot="footer" class="dialog-footer" style="text-align: center; width: 100%;">
                <el-button type="primary" @click="TiShiBlon = false" style="margin-right: 30px;">是</el-button>
                <el-button type="primary" @click="TiShiBlon = false">否</el-button>
            </span>
        </el-dialog> -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                Id:"",
                TypeId:"",
                TiShiBlon:false,
                TiShiData:"",
                SetData:{
                    name:"",
                    City:[],
                    synopsis:"",
                    address:"",
                    receiver_name: "",
                    receiver_mobile: "",
                    receiver_address: "",
                    email:"",
                    is_public_synopsis:2,
                    user_group_id: "",
                },
                SetGeRenData:{
                    gender:"",
                    mobile:"",
                    is_public:2,
                    work_mobile:"",
                    native_place:[],
                    nation:"",
                    id_card:"",
                    political_party:"",
                    degree:"",
                    qualification:"",
                    major:"",
                    work_title:"",
                    title_level:"",
                    pf_work:"",
                    job_content:"",
                    nature:"",
                    birthday: "",
                    marriage:"",
                    religion:"",
                    skill_method:"",
                    consultation_direction:"",
                    social_organization:"",
                },
                SetGongSiData:{
                    legal_person:"",
                    legal_license:"",
                    link_name:"",
                    link_mobile:"",
                    link_email:"",
                    institutions:"",
                    business_field:"",
                    mechanism_website:"",
                    mechanism_wnumber:"",
                    social_institution:"",
                },
                // TypeData:[],
                MingZuData:"",
                CityData:[],
                ConfigDisabled:false,
                PoliticalPartyData: [
                    { id: 1, name: '中共党员' },
                    { id: 2, name: '中共预备党员' },
                    { id: 3, name: '共青团员' },
                    { id: 4, name: '民主党派' },
                    { id: 5, name: '无党派人士' },
                    { id: 6, name: '群众' }
                ],
                GradeOptions: {
                    医师: ['住院医师', '主治医师', '副主任医师', '主任医师'],
                    护士: ['护士', '护师', '主管护师', '副主任护师', '主任护师'],
                    心理治疗师: ['初级心理治疗师', '中级心理治疗师', '心理师', '副高级心理师', '高级心理师'],
                    大学教师: ['助教', '讲师', '副教授', '教授'],
                    非大学教师: ['三级教师', '二级教师', '一级教师', '高级教师', '正高级教师', '其他'],
                    研究员:['研究实习员', '助理研究员', '副研究员', '研究员'],
                    无: ['无'],
                    其他: ['其他'],
                },
                skillMethodOptions: ['精神分析/心理动力', '认知行为', '人本主义', '家庭', '后现代'],
                consultationDirectionOptions: ['情绪调节', '恋爱、婚姻与家庭', '儿童青少年', '老年心理', '职场心理', '人际关系', '性心理', '个人发展与成长', '成瘾与行为控制'],
            }
        },
        props:{
            Type:"",
            PageDisabled:false,
        },
        mounted() {
            this.TypeId = this.$route.query.type || this.Type;
            this.GetCommType();
            this.ConfigDisabled = this.PageDisabled;
            
            // 1. 优先读取 basicInfoData
            const basicInfoData = localStorage.getItem('basicInfoData');
            if (basicInfoData) {
                try {
                    const parsedData = JSON.parse(basicInfoData);
                    if (parsedData.TypeId == this.TypeId) {
                        this.SetData = parsedData.SetData;
                        this.SetGeRenData = parsedData.SetGeRenData;
                        this.SetGongSiData = parsedData.SetGongSiData;
                        return;
                    }
                } catch (e) {
                    console.error('解析basicInfoData失败:', e);
                }
            }

            // 2. 再判断是否是编辑模式（InfoData）
            if (this.$route.query.type && !this.$route.query.stste) {
                const infoData = localStorage.getItem("InfoData");
                if (!infoData) {
                    this.$message.error('数据获取失败，请返回重试');
                    this.$router.push('/UserInfo');
                    return;
                }
                try {
                    JSON.parse(infoData); // 只是校验格式
                    this.getLocalData(this.$route.query.type);
                } catch (e) {
                    this.$message.error('数据格式错误，请返回重试');
                    this.$router.push('/UserInfo');
                    return;
                }
            } else {
                // 3. 最后才 fetchLatestInfo
                this.fetchLatestInfo();
            }
        },
        methods: {
            // 获取最新提交的信息
            fetchLatestInfo() {
                const typeId = this.TypeId;
                if (typeId == 1) {
                    // 获取个人最新信息
                    this.$get("api/user/peopleSearch", {params: {page: 1}})
                    .then(res => {
                        if (res.data.code == 1 && res.data.data && res.data.data.data && res.data.data.data.length > 0) {
                            // 获取最新提交的一条个人信息
                            const data = res.data.data.data[0];
                            this.SetData = {
                                name: data.name || "",
                                City: data.province && data.city ? [parseInt(data.province), parseInt(data.city)] : [],
                                synopsis: data.synopsis || "",
                                address: data.address || "",
                                receiver_name: data.receiver_name || "",
                                receiver_mobile: data.receiver_mobile || "",
                                receiver_address: data.receiver_address || "",
                                email: data.email || "",
                                is_public_synopsis: (data.is_public_synopsis !== undefined && data.is_public_synopsis !== null) ? parseInt(data.is_public_synopsis) || 2 : 2,
                            };
                            
                            // 处理政治面貌数据
                            let politicalParty = data.political_party;
                            if (politicalParty && !isNaN(politicalParty)) {
                                const partyItem = this.PoliticalPartyData.find(item => item.id == politicalParty);
                                if (partyItem) {
                                    politicalParty = partyItem.name;
                                }
                            }
                            
                            this.SetGeRenData = {
                                gender: data.gender || "",
                                mobile: data.mobile || "",
                                is_public: data.is_public || 2,
                                work_mobile: data.work_mobile || "",
                                native_place: data.native_place ? data.native_place.split("-") : [],
                                nation: data.nation || "",
                                id_card: data.id_card || "",
                                political_party: politicalParty || "",
                                degree: data.degree || "",
                                qualification: data.qualification || "",
                                major: data.major || "",
                                work_title: data.work_title || "",
                                title_level: data.title_level || "",
                                pf_work: data.pf_work || "",
                                job_content: data.job_content || "",
                                nature: data.nature || "",
                                birthday: data.birthday || "",
                                marriage: data.marriage || "",
                                religion: data.religion || "",
                                skill_method: data.skill_method_other || data.skill_method || "",
                                consultation_direction: data.consultation_direction_other || data.consultation_direction || "",
                                social_organization: data.social_organization || "",
                            };
                            
                            // 如果没有获取到数据，尝试获取会员信息
                            if (!data.name) {
                                this.GetData();
                            }
                        } else {
                            // 如果获取最新信息失败，先调用getUserInfo获取用户基本信息
                            this.$post("api/user/getUserInfo")
                            .then(userRes => {
                                if (userRes.data.code == 1 && userRes.data.data) {
                                    const userData = userRes.data.data;
                                    // 将姓名和手机号填入表单
                                    if (userData.username) {
                                        this.SetData.name = userData.username;
                                    }
                                    if (userData.mobile) {
                                        this.SetGeRenData.mobile = userData.mobile;
                                    }
                                }
                                // 然后尝试获取会员信息
                                this.GetData();
                            })
                            .catch(() => {
                                // 出错时尝试获取会员信息
                                this.GetData();
                            });
                        }
                    })
                    .catch(() => {
                        // 出错时先调用getUserInfo获取用户基本信息
                        this.$post("api/user/getUserInfo")
                        .then(userRes => {
                            if (userRes.data.code == 1 && userRes.data.data) {
                                const userData = userRes.data.data;
                                // 将姓名和手机号填入表单
                                if (userData.username) {
                                    this.SetData.name = userData.username;
                                }
                                if (userData.mobile) {
                                    this.SetGeRenData.mobile = userData.mobile;
                                }
                            }
                            // 然后尝试获取会员信息
                            this.GetData();
                        })
                        .catch(() => {
                            // 出错时尝试获取会员信息
                            this.GetData();
                        });
                    });
                } else if (typeId == 2) {
                    // 获取机构最新信息
                    this.$get("api/user/companySearch", {params: {page: 1}})
                    .then(res => {
                        if (res.data.code == 1 && res.data.data && res.data.data.data && res.data.data.data.length > 0) {
                            // 获取最新提交的一条机构信息
                            const data = res.data.data.data[0];
                            this.SetData = {
                                name: data.name || "",
                                City: data.province && data.city ? [parseInt(data.province), parseInt(data.city)] : [],
                                synopsis: data.synopsis || "",
                                address: data.address || "",
                                receiver_name: data.receiver_name || "",
                                receiver_mobile: data.receiver_mobile || "",
                                receiver_address: data.receiver_address || "",
                                email: data.email || "",
                                is_public_synopsis: (data.is_public_synopsis !== undefined && data.is_public_synopsis !== null) ? parseInt(data.is_public_synopsis) || 2 : 2,
                            };
                            
                            this.SetGongSiData = {
                                legal_person: data.legal_person || "",
                                legal_license: data.legal_license || "",
                                link_name: data.link_name || "",
                                link_mobile: data.link_mobile || "",
                                link_email: data.link_email || "",
                                institutions: data.institutions || "",
                                business_field: data.business_field || "",
                                mechanism_website: data.mechanism_website || "",
                                mechanism_wnumber: data.mechanism_wnumber || "",
                                social_institution: data.social_institution || "",
                            };
                        } else {
                            // 如果获取最新信息失败，重置表单
                            this.SetData = {
                                City: [],
                                synopsis: "",
                                address: "",
                                name: "",
                                receiver_name: "",
                                receiver_mobile: "",
                                receiver_address: "",
                                email: "",
                                is_public_synopsis: 2,
                            };
                        }
                    })
                    .catch(() => {
                        // 出错时重置表单
                        this.SetData = {
                            City: [],
                            synopsis: "",
                            address: "",
                            name: "",
                            receiver_name: "",
                            receiver_mobile: "",
                            receiver_address: "",
                            email: "",
                            is_public_synopsis: 2,
                        };
                    });
                }
            },
            GetData(){
                // 首先检查是否是编辑模式，如果是编辑模式则不调用 xinXieUserInfo 接口
                if(this.$route.query.type && !this.$route.query.stste) {
                    console.log('编辑模式，不调用 xinXieUserInfo 接口');
                    return;
                }

                // 检查是否有本地存储的数据
                const savedData = localStorage.getItem('basicInfoData');
                if(savedData) {
                    try {
                        const parsedData = JSON.parse(savedData);
                        if(parsedData.TypeId == this.TypeId) {
                            console.log('使用本地存储的数据');
                            this.SetData = parsedData.SetData;
                            this.SetGeRenData = parsedData.SetGeRenData;
                            this.SetGongSiData = parsedData.SetGongSiData;
                            return; // 有本地数据就直接返回，不调用接口
                        }
                    } catch (e) {
                        console.error('解析本地数据失败:', e);
                    }
                }

                // 只有在非编辑模式且没有本地数据时，才调用接口
                this.$get("api/join_in/xinXieUserInfo")
                .then(res => {
                    if(res.data.code == 1){
                        var res = res.data.data;
                        
                        // 如果政治面貌是数字ID，转换为对应的名称
                        let partyName = res.Party;
                        if(res.Party && !isNaN(res.Party)) {
                            const partyItem = this.PoliticalPartyData.find(item => item.id == res.Party);
                            if(partyItem) {
                                partyName = partyItem.name;
                            }
                        }
                        
                        // 使用接口数据
                        this.SetData.name = res.username;
                        this.SetData.address = res.address;
                        this.SetGeRenData = {
                            gender: res.sex.toString(),
                            mobile: res.mobile,
                            is_public: res.is_public || 2,
                            work_mobile: res.work_mobile,
                            nation: res.National,
                            id_card: res.idcard,
                            political_party: partyName,
                            degree: res.Grade,
                            qualification: res.qualification,
                            major: res.Major,
                            work_title: res.JobTitle,
                            title_level: res.title_level,
                            pf_work: res.UnitPostition,
                            job_content: res.job_content,
                            nature: res.nature,
                            birthday: res.birthday,
                            marriage: res.marriage,
                            religion: res.religion,
                            skill_method: res.skill_method || "",
                            skill_method_other: res.skill_method_other || "",
                            consultation_direction: res.consultation_direction || "",
                            consultation_direction_other: res.consultation_direction_other || "",
                            social_organization: res.social_organization || "",
                        }
                    }
                })
            },
            getLocalData(i){
                this.TypeId = i;
                const InfoData = JSON.parse(localStorage.getItem("InfoData"));
                console.log('BasicInfo getLocalData: 获取到的数据:', InfoData);
                
                if (!InfoData) {
                    this.$message.error('数据获取失败，请返回重试');
                    this.$router.push('/UserInfo');
                    return;
                }

                // 现在InfoData直接就是详情数据
                const data = InfoData;
                
                // 如果有user_group信息，设置user_group_id（编辑保存第1步必须带回，否则会清空库里的注册级别）
                if (data.user_group && data.user_group.length > 0) {
                    data.user_group_id = data.user_group[0].id;
                }
                
                this.Id = data.id || '';
                this.SetData = {
                    City: [
                        parseInt(data.province || '') || null,
                        parseInt(data.city || '') || null
                    ].filter(Boolean),
                    synopsis: data.synopsis || '',
                    address: data.address || '',
                    name: data.name || '',
                    receiver_name: data.receiver_name || "",
                    receiver_mobile: data.receiver_mobile || "",
                    receiver_address: data.receiver_address || "",
                    email: data.email || "",
                    is_public_synopsis: (data.is_public_synopsis !== undefined && data.is_public_synopsis !== null) ? parseInt(data.is_public_synopsis) || 2 : 2,
                    user_group_id: data.user_group_id || "",
                };

                if(i == 1) {
                    // 处理政治面貌数据
                    let politicalParty = data.political_party;
                    if(politicalParty && !isNaN(politicalParty)) {
                        const partyItem = this.PoliticalPartyData.find(item => item.id == politicalParty);
                        if(partyItem) {
                            politicalParty = partyItem.name;
                        }
                    }
                    
                    this.SetGeRenData = {
                        gender: data.gender || '',
                        mobile: data.mobile || '',
                        is_public: data.is_public || 2,
                        work_mobile: data.work_mobile || '',
                        native_place: data.native_place ? data.native_place.split("-") : [],
                        nation: data.nation || '',
                        id_card: data.id_card || '',
                        political_party: politicalParty || '',
                        degree: data.degree || '',
                        qualification: data.qualification || '',
                        major: data.major || '',
                        work_title: data.work_title || '',
                        title_level: data.title_level || '',
                        pf_work: data.pf_work || '',
                        job_content: data.job_content || '',
                        nature: data.nature || '',
                        birthday: data.birthday || '',
                        marriage: data.marriage || '',
                        religion: data.religion || '',
                        skill_method: data.skill_method || '',
                        skill_method_other: data.skill_method_other || '',
                        consultation_direction: data.consultation_direction || '',
                        consultation_direction_other: data.consultation_direction_other || '',
                        social_organization: data.social_organization || '',
                    };
                }

                if(i == 2) {
                    this.SetGongSiData = {
                        legal_person: data.legal_person || '',
                        legal_license: data.legal_license || '',
                        link_name: data.link_name || '',
                        link_mobile: data.link_mobile || '',
                        link_email: data.link_email || '',
                        institutions: data.institutions || '',
                        business_field: data.business_field || '',
                        mechanism_website: data.mechanism_website || '',
                        mechanism_wnumber: data.mechanism_wnumber || '',
                        social_institution: data.social_institution || '',
                    };
                }
                
                console.log('BasicInfo getLocalData: 设置后的数据:', {
                    SetData: this.SetData,
                    SetGeRenData: this.SetGeRenData,
                    SetGongSiData: this.SetGongSiData
                });
            },
            GetCommType(){
                this.$get("api/common/nations")
                .then(res => {
                     if(res.data.code == 1){
                         this.MingZuData = res.data.data;
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })
                this.$get("api/common/areaList")
                .then(res => {
                     if(res.data.code == 1){
                         this.CityData =res.data.data;
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })
            },
            ToggleStep(){
                if(this.ConfigDisabled){return;}
                
                // 保存表单数据到 localStorage
                const formData = {
                    SetData: this.SetData,
                    SetGeRenData: this.SetGeRenData,
                    SetGongSiData: this.SetGongSiData,
                    TypeId: this.TypeId
                };
                localStorage.setItem('basicInfoData', JSON.stringify(formData));
                
                var Url = "api/join_in/addInformation";
                var Quy = "";
                if(this.TypeId ==1){
                    if(this.SetGeRenData.gender == ""){this.$message.error("请选择性别");return;}
                    if(!this.$Global.isPhone(this.SetGeRenData.mobile)){this.$message.error("请输入有效手机号");return;}
                    if(!this.SetGeRenData.is_public || this.SetGeRenData.is_public == ""){this.$message.error("请选择是否向公众公布您的联系方式");return;}
                    if(this.SetGeRenData.birthday == ""){this.$message.error("请选择出生年月");return;}
                    if(!this.SetGeRenData.native_place || this.SetGeRenData.native_place.length == 0){this.$message.error("请选择籍贯");return;}
                    if(this.SetGeRenData.nation == ""){this.$message.error("请选择民族");return;}
                    if(!this.$Global.isCard(this.SetGeRenData.id_card)){this.$message.error("请输入有效身份证号码");return;}
                    if(this.SetGeRenData.political_party == ""){this.$message.error("请选择政治面貌");return;}
                    if(this.SetGeRenData.qualification == undefined){this.$message.error("请选择学历");return;}
                    if(this.SetGeRenData.major == ""){this.$message.error("请输入专业");return;}
                    if(this.SetGeRenData.work_title == ""){this.$message.error("请输入技术职称");return;}
                    if(this.SetGeRenData.pf_work == ""){this.$message.error("请输入工作单位");return;}
                    if(this.SetGeRenData.birthday == ""){this.$message.error("请输入出生年月");return;}
                    if(this.SetGeRenData.religion == undefined){this.$message.error("请输入宗教信仰");return;}
                    if(this.SetGeRenData.marriage == undefined){this.$message.error("请选择婚姻状况");return;}
                    if(this.SetGeRenData.skill_method == "" || this.SetGeRenData.skill_method === "其他"){this.$message.error("请输入擅长技术与方法");return;}
                    if(this.SetGeRenData.consultation_direction == "" || this.SetGeRenData.consultation_direction === "其他"){this.$message.error("请输入咨询方向");return;}
                    if(this.SetGeRenData.social_organization == ""){this.$message.error("请输入社会组织任职");return;}

                    console.log(this.SetGeRenData.qualification)
                    Quy = Object.assign({}, this.SetData, this.SetGeRenData);
                    if(Quy.native_place.length>0){
                        Quy.native_place = Quy.native_place.join("-")
                    }
                }else{
                    if(this.SetGongSiData.legal_person == ""){this.$message.error("请输入法人名称");return;}
                    if(this.SetGongSiData.legal_license == ""){this.$message.error("请上传企业营业执照");return;}
                    if(this.SetGongSiData.link_name == ""){this.$message.error("请输入联系人");return;}
                    if(!this.$Global.isPhone(this.SetGongSiData.link_mobile)){this.$message.error("请输入有效联系电话");return;}
                    if(!this.$Global.isEmail(this.SetGongSiData.link_email)){this.$message.error("请输入有效联系邮箱");return;}
                    if(this.SetGongSiData.institutions == ""){this.$message.error("请输入单位性质");return;}
                    if(this.SetGongSiData.business_field == ""){this.$message.error("请输入业务领域");return;}
                    // if(this.SetGongSiData.social_institution == ""){this.$message.error("请输入公众号");return;}
                    // if(this.SetGongSiData.mechanism_wnumber == ""){this.$message.error("请输入社会机构");return;}
                    // if(this.SetGongSiData.mechanism_website == ""){this.$message.error("请输入网址");return;}
                    Url = "api/join_in/addCompany";
                    Quy = Object.assign({}, this.SetData, this.SetGongSiData);
                }
                // if(this.SetData.user_group_id == ""){this.$message.error("请选择注册类型");return;}
                if(this.SetData.name == ""){this.$message.error("请输入"+this.TypeId ==1?'姓名':'机构名称');return;}
                if(this.SetData.City.length == 0){this.$message.error("请选择通信地址");return;}
                if(this.SetData.address == ""){this.$message.error("请输入详细地址");return;}
                if(this.SetData.synopsis == ""){this.$message.error("请输入简介");return;}
                if(this.SetData.email == ""){this.$message.error("请输入邮箱");return;}
                if(!this.$Global.isEmail(this.SetData.email)){this.$message.error("请输入有效邮箱");return;}
                if(this.SetData.receiver_name == ""){this.$message.error("请输入收件人姓名");return;}
                if(!this.$Global.isPhone(this.SetData.receiver_mobile)){this.$message.error("请输入有效收件人手机号");return;}
                if(this.SetData.receiver_address == ""){this.$message.error("请输入收件人详细地址");return;}
                Quy.province = Quy.City[0];
                Quy.city = Quy.City[1];
                Quy.id = this.Id;
                // 编辑时保留注册级别，避免空值覆盖数据库 user_group_id
                if (!Quy.user_group_id) {
                    try {
                        const infoData = JSON.parse(localStorage.getItem("InfoData") || "null");
                        if (infoData) {
                            if (infoData.user_group && infoData.user_group.length > 0) {
                                Quy.user_group_id = infoData.user_group[0].id;
                            } else if (infoData.user_group_id) {
                                Quy.user_group_id = infoData.user_group_id;
                            }
                        }
                    } catch (e) { /* ignore */ }
                    if (!Quy.user_group_id && this.SetData.user_group_id) {
                        Quy.user_group_id = this.SetData.user_group_id;
                    }
                }

                this.$post(Url,Quy).then(res => {
                     if(res.data.code == 1 ){
                         this.$message.success(res.data.msg);
                         var Obj = {
                             id:res.data.data.id,
                         }
                         this.$emit("PageBtn","next",Obj)
                     }else{
                         if(res.data.code == -99){
                             this.$emit("PageBtn","next",Obj)
                         }
                     }
                })
            },
            UpFile({ file,data}) {
                var isJPG = file.type == 'image/jpeg' || file.type == 'image/png';
                if (!isJPG) {
                  this.$message.error('营业执照只能是 JPG/PNG 格式');
                  return false;
                }else{
                    var fd = new FormData()
                    fd.append('file',file);
                    this.$Global.FileUpData(fd,(res)=>{
                        this.SetGongSiData.legal_license = res.data.url;
                        this.$forceUpdate();
                    })
                }
            },
            OpenLock(res){
                this.$Global.previewFile(res)
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
            GoHref(){
                this.TiShiBlon = false;
                window.open("https://www.camh.org.cn/")
            },
            // work_title() {
            //     this.SetGeRenData.grade = '';
            // }

            work_title() {
                if (this.SetGeRenData.work_title === "无") {
                    this.SetGeRenData.title_level = "无";
                } else if (this.SetGeRenData.work_title === "其他") {
                    this.SetGeRenData.title_level = "其他";
                } else {
                    this.SetGeRenData.title_level = "";
                }
            },
            GoToAbout() {
                this.$router.push({
                    path: '/About',
                    query: { id: 3 }
                });
            },
            handleSkillMethodChange(value) {
                // 当选择"其他"时，字段值已经是"其他"，输入框会自动显示
                // 当选择其他选项时，字段值就是选项的值
            },
            handleOtherInputBlur() {
                // 如果输入框为空，切换回下拉框
                if (!this.SetGeRenData.skill_method || this.SetGeRenData.skill_method.trim() === '') {
                    this.SetGeRenData.skill_method = '';
                }
            },
            handleConsultationDirectionChange(value) {
                // 当选择"其他"时，字段值已经是"其他"，输入框会自动显示
                // 当选择其他选项时，字段值就是选项的值
            },
            handleConsultationDirectionInputBlur() {
                // 如果输入框为空，切换回下拉框
                if (!this.SetGeRenData.consultation_direction || this.SetGeRenData.consultation_direction.trim() === '') {
                    this.SetGeRenData.consultation_direction = '';
                }
            },
            isSkillMethodPreset(value) {
                // 如果值为空，显示下拉框
                if (!value || value === '') return true;
                // 如果是"其他"，显示输入框
                if (value === '其他') return false;
                // 如果是预设选项之一，显示下拉框
                return this.skillMethodOptions.includes(value);
            },
            isConsultationDirectionPreset(value) {
                // 如果值为空，显示下拉框
                if (!value || value === '') return true;
                // 如果是"其他"，显示输入框
                if (value === '其他') return false;
                // 如果是预设选项之一，显示下拉框
                return this.consultationDirectionOptions.includes(value);
            },
        },
        watch: {
            Type: function (val) {
                this.TypeId = val;
                console.log('类型改变为:', this.TypeId);
                
                // 检查是否是编辑模式
                if(this.$route.query.type && !this.$route.query.stste) {
                    console.log('编辑模式，从本地获取数据');
                    this.getLocalData(val);
                    return;
                }
                
                // 获取最新提交的信息
                this.fetchLatestInfo();
            }
        },
    }
</script>
<style scoped>
    .MarTop {
        margin-top: 20px;
    }
    /* .StepHead{
        
    } */
    .Steps{
        display: none;
        align-items: center;
        margin: 30px 0;
        display: none;
    }
    .StepsItem{
        flex: 1;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #F5F5F5;
        position: relative;
        font-weight: 400;
        font-size: 18px;
        color: #999;
    }
    .StepJiBen{
        margin:0 auto;
        width: 60%;
    }
    .StepJiBenItem{
        display: flex;
        margin-bottom: 20px;
    }
    .StepJiBenItemTit{
        width: 240px;
        text-align: right;
        margin-right: 20px;
    }
    .StepJiBenItemTit .Icon{
        color: #ff0000;
        font-weight: 400;
        font-size: 20px;
        margin-right: 5px;
    }
    .StepJiBenItemTit .Tit{
        font-weight: 400;
        font-size: 16px;
        color: #666;
    }
    .StepJiBenItemVal{
        flex: 1;
    }
    .StepJiBenItemVal .WidMax{
        width: 100%;
    }
    .StepJiBenItemVal.DisFlex{
        display: flex;
    }
    .StepCommFileBtn{
        padding: 3px 35px;
        background: #F5F5F5;
        border-radius: 5px;
        border: 1px solid #CCCCCC;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        margin-left: 20px;
    }
    .StepCommFileMsg{
        font-weight: 400;
        font-size: 18px;
        color: #999999;
    }
    .StepCommFileLock{
        font-size: 16px;
        color: #0385EB;
        padding: 0 10px;
    }
    .StepCommFileImg{
        border: 1px solid #ddd;
        padding: 2px;
        cursor: pointer;
        margin-left: 5px;
    }
    .StepCommFileImg img{
        width: 50px;
        height: 50px;
    }
    .StepBtns{
        display: flex;
        align-items: center;
        justify-content: center;
        margin:  30px 0
    }
    .StepBtn{
        margin-right: 20px;
        width: 180px;
        text-align: center;
        padding: 7px 15px;
        color: #fff;
        font-size: 18px;
        background: #0286eb;
        border-radius: 20px;
        cursor: pointer;
    }
    .StepBtn.StpepDisabled{
        background: #80c1f3;
        cursor: no-drop;
    }
    .Table {
        width: 99%;
        margin: 10px auto;
        border-radius: 5px;
        border-collapse: collapse;
    }
    .Table td {
        border: 1px solid #e4eaec;
        padding: 10px;
        font-weight: 400;
        font-size: 16px;
        color: #666;
    }
    .Table .State{
        padding-right: 10px;
    }
    .Table .Th {
        color: #000000;
        font-size: 16px;
        padding: 10px;
        font-weight: 700;
    }
    
    .Table td .Red {
        color: #d51938;
        font-weight: 700;
        vertical-align: middle;
        /* margin-right: 10px; */
    }
    .Table .TableDis {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .WidMax{
        width: 100%;
    }
    @media only screen and (max-width: 550px) {
       .Steps{
           display: flex;
       }
       .StepJiBen{
           width: 100%;
           margin: 0;
       }
       .StepJiBenItemTit .Tit{
           font-size: 16px;
       }
    }
    .info-save {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
    .dialog-footer .el-button--primary {
        background-color: #0385EB;
        border-color: #0385EB;
    }
    .dialog-footer .el-button--primary:hover {
        background-color: #0374d4;
        border-color: #0374d4;
    }
    p {
        white-space: nowrap;
        color: #ff002b;
        font-size: 15px;
        letter-spacing: 2px;
    }
    p a {
        color: #ff002b;
        text-decoration: none;
        cursor: pointer;
    }
</style>